export default "__VITE_ASSET__D8VRtx69__"